import { createFileRoute } from '@tanstack/react-router';
import { CampaignsWelcomeRouteView } from '@/pages/workspaces/automations/routing';
import { LastWorkspaceResolver } from './-components';

/** Sends the reader on to the Automations list. No `appBundle`: this URL has no `journeys` segment. */
function AutomationsWelcomeRoute() {
  return (
    <LastWorkspaceResolver>
      <CampaignsWelcomeRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/welcome/')({
  component: AutomationsWelcomeRoute,
});
